<template>
  <div class="stat-filter">
    <mobile-collapse title="Фильтры">
      <div class="stat-filter__main-fields d-flex justify-space-between">
        <div class="stat-filter__main-left d-md-flex align-center">
          <div class="filters-container">
            <!--            <div class="main-filters">-->
            <div class="stat-filter-col">
              <label class="stat-filter-col__label">
                выбрать <br />
                дату:
              </label>
              <div class="date-picker-block stat-filter-col__content">
                <slot name="date-picker">
                  <v-dialog
                    v-if="isMobileScreen"
                    v-model="menu"
                    fullscreen
                    transition="dialog-bottom-transition"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        class="button-datepicker"
                        height="48"
                        color="#fff"
                        depressed
                        v-on="on"
                        @click="openMobileDatepicker"
                      >
                        <font-awesome-icon
                          color="#FF9100"
                          icon="calendar-alt"
                        />
                        <span class="d-flex font-weight-light">
                          {{ fromDateFormatted }} - {{ toDateFormatted }}
                        </span>
                      </v-btn>
                    </template>
                    <v-card class="d-flex flex-column pa-3">
                      <v-date-picker
                        v-model="datesRange"
                        event-color="#FF9D00"
                        :first-day-of-week="1"
                        no-title
                        locale="ru"
                        reactive
                        range
                        full-width
                        class="flex-grow-1"
                      />
                      <div class="d-flex justify-end mt-3">
                        <v-btn
                          text
                          color="primary"
                          @click="cancelMobileDatepicker"
                        >
                          Отмена
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="confirmMobileDatepicker"
                        >
                          Ок
                        </v-btn>
                      </div>
                    </v-card>
                  </v-dialog>
                  <v-menu
                    v-else
                    ref="menu"
                    v-model="menu"
                    :return-value.sync="datesRange"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        class="button-datepicker"
                        height="48"
                        color="#fff"
                        depressed
                        v-on="on"
                      >
                        <font-awesome-icon
                          color="#FF9100"
                          icon="calendar-alt"
                        />
                        <span class="d-flex font-weight-light">
                          {{ fromDateFormatted }} - {{ toDateFormatted }}
                        </span>
                      </v-btn>
                    </template>
                    <div class="datepicker">
                      <v-date-picker
                        v-model="datesRange"
                        event-color="#FF9D00"
                        :first-day-of-week="1"
                        no-title
                        locale="ru"
                        reactive
                        range
                        @change="$refs.menu.save(datesRange)"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu = false">
                          Отмена
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu.save(datesRange)"
                        >
                          Ок
                        </v-btn>
                      </v-date-picker>
                    </div>
                  </v-menu>
                </slot>
              </div>
            </div>

            <div class="stat-filter-col filial-select-col">
              <label
                class="stat-filter-col__label"
              >выбрать <br />
                филиал:</label>
              <div class="stat-filter-col__content">
                <filial-select-wits-presets
                  :disable-presets="disableFilialPresets"
                  :value="filialDefault"
                  :multiple="multipleFilialSelect"
                  @change="changeFilialFilter"
                />
              </div>
            </div>
            <!--            </div>-->
            <div class="stat-filter-col additional-filter">
              <slot name="additional-filter"></slot>
            </div>

            <div class="stat-filter-col">
              <v-btn
                style="border-radius: 10px"
                height="48px"
                depressed
                color="#D3D5D9"
                @click="applyFilter"
              >
                Применить
              </v-btn>
            </div>
            <div class="stat-filter-col">
              <slot name="afterApply" :filter="filterData"></slot>
            </div>
          </div>
        </div>

        <div v-if="!hideDaysDiff" class="stat-filter__main-right">
          <div v-if="daysDiff" class="time-diff">
            <span class="time-diff_label">вывод: </span>
            <span class="time-diff_value">{{ daysDiff }}</span>
            {{ daysDiffLabel }}
          </div>
        </div>
      </div>
    </mobile-collapse>
  </div>
</template>

<script>
  import moment from 'moment'
  import { numWord } from '@/util/string'
  import snackbarMessage from '@/mixins/snackbar-message'
  import FilialSelectWitsPresets from '@/components/ui/filial-with-presets/FilialSelectWitsPresets.vue'
  import MobileCollapse from '@/components/mobile/MobileCollapse.vue'
  import mixinMobileScreen from '@/mixins/mobile-screen'
  import { DateTime } from 'luxon'

  export default {
    name: 'StatTopFilter',
    components: { FilialSelectWitsPresets, MobileCollapse },
    mixins: [snackbarMessage, mixinMobileScreen],
    props: {
      daysCount: {
        type: Number,
        default: 15,
      },
      lastMonth: {
        // Выводить статистику за текущий месяц
        type: Boolean,
        default: false,
      },
      endDate: {
        type: String,
        default: null,
      },
      startDate: {
        type: String,
        default: null,
      },
      disableFilialPresets: {
        type: Boolean,
        default: false,
      },
      multipleFilialSelect: {
        type: Boolean,
        default: false,
      },
      filialDefault: {
        default: null,
      },
      hideDaysDiff: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        showDatepicker: false,
        datesRange: [],
        datesRangeBackup: [],
        filialId: null,
        filialPreset: null,
        menu: false,
      }
    },
    computed: {
      fromDateMoment () {
        return moment(this.datesRange[0], 'YYYY-MM-DD')
      },
      toDateMoment () {
        return moment(this.datesRange[1], 'YYYY-MM-DD')
      },
      fromDateFormatted () {
        return this.fromDateMoment.isValid()
          ? this.fromDateMoment.format('DD.MM.YYYY')
          : '__.__.__'
      },
      toDateFormatted () {
        return this.toDateMoment.isValid()
          ? this.toDateMoment.format('DD.MM.YYYY')
          : '__.__.__'
      },
      daysDiff () {
        if (this.fromDateMoment.isValid() && this.toDateMoment.isValid()) {
          return this.toDateMoment.diff(this.fromDateMoment, 'days') + 1
        } else {
          return ''
        }
      },
      daysDiffLabel () {
        return this.daysDiff ? numWord(this.daysDiff, 'день', 'дня', 'дней') : ''
      },
      filterData () {
        return {
          from: this.datesRange[0],
          to: this.datesRange[1],
          filialId: this.filialId,
          filialPreset: this.filialPreset,
        }
      },
    },
    created () {
      this.initFilterData()
      this.applyFilter()
    },

    methods: {
      initFilterData () {
        let startDate, endDate
        if (this.startDate && this.endDate) {
          startDate = this.startDate
          endDate = this.endDate
        } else if (this.lastMonth) {
          startDate = DateTime.now().set({ day: 1 }).toFormat('yyyy-LL-dd')
          endDate = DateTime.now().toFormat('yyyy-LL-dd')
        } else if (this.startDate) {
          startDate = this.startDate
          endDate = moment(startDate, 'YYYY-MM-DD')
            .add(this.daysCount - 1, 'days')
            .format('YYYY-MM-DD')
        } else {
          endDate = this.endDate || moment().format('YYYY-MM-DD')
          startDate = moment(endDate, 'YYYY-MM-DD')
            .subtract(this.daysCount - 1, 'days')
            .format('YYYY-MM-DD')
        }

        this.datesRange = [startDate, endDate]

        if (this.filialDefault) {
          if (parseInt(this.filialDefault)) {
            this.filialId = this.filialDefault
          } else {
            this.filialPreset = this.filialDefault
          }
        }
      },
      openMobileDatepicker () {
        this.datesRangeBackup = [...this.datesRange]
      },
      cancelMobileDatepicker () {
        this.datesRange = [...this.datesRangeBackup]
        this.menu = false
      },
      confirmMobileDatepicker () {
        this.menu = false
      },
      changeFilialFilter (data) {
        this.filialId = this.multipleFilialSelect ? [] : null
        this.filialPreset = null

        if (this.multipleFilialSelect) {
          const preset = data.find((item) => item.type === 'preset')

          if (preset) {
            this.filialPreset = preset.id
          } else {
            this.filialId = data.map((item) => item.id)
          }
        } else {
          if (data.id) {
            if (data.type === 'filial') {
              this.filialId = data.id
            } else {
              this.filialPreset = data.id
            }
          }
        }
      },
      applyFilter () {
        if (this.validate()) {
          this.$emit('applyFilter', this.filterData)
        }
      },
      validate () {
        if (
          this.fromDateMoment.isValid() &&
          this.toDateMoment.isValid() &&
          this.toDateMoment.diff(this.fromDateMoment, 'days') >= 0
        ) {
          this.showDatepicker = false
          return true
        } else {
          this.showErrorMessage('Выберите корректный диапазон дат')
          return false
        }
      },
    },
  }
</script>

<style lang="less" scoped>
.stat-filter {
  padding: 9px 15px;
  background: #f1f3f6;
  border-radius: 8px;
  margin-bottom: 30px;
  .media-sm({
      padding: 10px;
      flex-direction: column;
      align-items: flex-start !important;
    });

  .stat-filter-col {
    display: flex;
    align-items: center;
    margin-right: 15px;

    .media-sm({
      flex-direction: column;
      align-items: stretch;
      width: 100%;
      margin-right: 0;
      margin-bottom: 8px;

      .stat-filter-col__content,
      .button-datepicker,
      .v-btn,
      .v-select,
      .v-input {
        width: 100%;
      }
    });

    // метки из слотов лежат в чужих scope - до них достаём через ::v-deep
    ::v-deep .stat-filter-col__label {
      line-height: 1.1;
      margin-right: 15px;
      color: #949191;
    }

    &__label {
      line-height: 1.1;
      margin-right: 15px;
      color: #949191;

      @media (max-width: 1700px) {
        display: none !important;
      }

      @media (max-width: 1200px) {
        margin-bottom: 8px;

        br {
          display: none;
        }
      }

      .media-sm({
        margin-bottom: 10px;
        display: block;

        br {
          display: none;
        }
      });
    }

    @media (max-width: 1700px) {
      ::v-deep {
        .stat-filter__label {
          display: none !important;
        }
        .stat-filter-col__label {
          display: none !important;
        }

        .v-input--selection-controls.v-input--checkbox {
          margin-top: 8px;

          .v-label {
            font-size: 14px;
          }
        }
      }
    }

    &.filial-select-col {
      .stat-filter-col__content {
        max-width: 300px;
      }

      @media (max-width: 1200px) {
        // margin-top: 20px;
      }
    }
  }

  .date-picker-block {
    position: relative;

    .button-datepicker {
      font-size: 14px;
      border-radius: 10px;

      span {
        font-size: 12px;
        font-weight: 400;
      }

      svg {
        margin-right: 5px;
      }
    }

    .datepicker {
      position: absolute;
      left: 0;
      top: calc(100% + 5px);
      z-index: 10000;
    }
  }

  .time-diff {
    white-space: nowrap;

    &_label {
      color: #b9babb;
    }

    &_value {
      color: #e91e63;
    }

    .media-sm({
      margin-top: 15px;
    });
  }

  &__main-fields {
    align-items: center;

    @media (max-width: 1400px) {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  &__main-left {
    @media (max-width: 1700px) {
      align-items: flex-start !important;
    }
    @media (max-width: 1200px) {
      margin-bottom: 20px;
    }
    @media (max-width: 768px) {
      width: 100%;

      .stat-filter-col__content {
        width: 100%;
        max-width: 100% !important;
      }
      ::v-deep {
        .button-datepicker {
          width: 100% !important;
        }
        .v-select {
          max-width: 100% !important;
          width: 100%;
        }
      }
    }
  }

  &__right {
  }
}

.filters-container {
  display: flex;
  align-items: center;

  @media (max-width: 1700px) {
    align-items: flex-start;
    //flex-direction: column;
  }

  // ниже 1200 фильтры в один ряд уже не помещаются - переносим колонками
  @media (max-width: 1200px) {
    flex-wrap: wrap;
    row-gap: 8px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
}

.main-filters {
  display: flex;
  align-items: center;

  @media (max-width: 1200px) {
    align-items: flex-start;
    flex-direction: column;
  }
}

.additional-filter {
  @media (max-width: 1700px) {
    //margin-top: 20px;
  }
}
</style>
